// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27180%27 height=%27180%27%3E%3Cfilter id=%27g%27%3E%3CfeTurbulence type=%27fractalNoise%27 baseFrequency=%270.9%27 numOctaves=%272%27 stitchTiles=%27stitch%27/%3E%3CfeColorMatrix values=%270 0 0 0 0.45 0 0 0 0 0.4 0 0 0 0 0.33 0 0 0 0.55 0%27/%3E%3C/filter%3E%3Crect width=%27100%25%27 height=%27100%25%27 filter=%27url%28%23g%29%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Página /contatos — estética do flyer (bege texturizado, serifa suave, botões em pílula) */

.mb-contatos {
  --mb-fundo: #ece5d5;
  --mb-fundo-claro: #f1ebdd;
  --mb-texto: #6a625b;
  --mb-texto-forte: #57504a;
  --mb-marrom: #6e645b;
  --mb-rosa: #e2457e;
  --mb-botao: rgba(246, 242, 233, 0.92);

  position: relative;
  min-height: 100vh;
  min-height: 100dvh;
  overflow: hidden;
  background-color: var(--mb-fundo);
  background-image: radial-gradient(38% 30% at 50% 42%, var(--mb-fundo-claro) 0%, rgba(236, 229, 213, 0) 100%);
  color: var(--mb-texto);
  font-family: 'Lexend', 'Inter', system-ui, sans-serif;
  -webkit-font-smoothing: antialiased;
}

.mb-contatos__grao {
  position: absolute;
  inset: 0;
  pointer-events: none;
  opacity: 0.32;
  mix-blend-mode: multiply;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.mb-contatos__arco {
  position: absolute;
  width: 120vw;
  height: 120vw;
  left: 78vw;
  top: -50vw;
  border: 1px solid rgba(87, 80, 74, 0.35);
  border-radius: 50%;
  pointer-events: none;
}

/* Frascos decorativos */
.mb-contatos__frasco {
  position: absolute;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  height: auto;
}

.mb-contatos__frasco--212 {
  top: 0;
  left: 0;
  width: clamp(230px, 62vw, 560px);
}

.mb-contatos__frasco--chanel {
  right: 0;
  top: clamp(330px, 36%, 520px);
  width: clamp(120px, 30vw, 400px);
}

.mb-contatos__frasco--egeo {
  left: 0;
  bottom: 0;
  width: clamp(130px, 34vw, 380px);
}

/* Conteúdo */
.mb-contatos__conteudo {
  position: relative;
  z-index: 1;
  box-sizing: border-box;
  width: 100%;
  max-width: 440px;
  margin: 0 auto;
  padding: clamp(150px, 40vw, 220px) 22px 48px;
  display: flex;
  flex-direction: column;
}

.mb-contatos__logo {
  margin: 0 0 30px;
  width: min(100%, 300px);
  aspect-ratio: 2782 / 456;
  background-color: var(--mb-texto-forte);
  mask: var(--mb-logo) center / contain no-repeat;
}

.mb-contatos__chamada {
  margin: 0 0 6px;
  font-weight: 300;
  font-size: 1.02rem;
  letter-spacing: 0.2em;
  line-height: 1.35;
  color: var(--mb-texto);
}

.mb-contatos__destaque {
  margin: 0 0 34px;
  max-width: 11ch;
  font-family: 'Fraunces', Georgia, serif;
  font-weight: 600;
  font-variation-settings: 'SOFT' 100;
  font-size: clamp(2.35rem, 10.5vw, 3.1rem);
  line-height: 1.02;
  letter-spacing: -0.01em;
  background: linear-gradient(180deg, #5c554f 0%, #7d746b 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.mb-contatos__destaque span {
  font-weight: 500;
}

/* Botões */
.mb-contatos__links {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 52px;
}

.mb-contatos__botao {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  max-width: 340px;
  box-sizing: border-box;
  padding: 14px 24px 14px 16px;
  border-radius: 999px;
  background: var(--mb-botao);
  border: 1px solid rgba(255, 255, 255, 0.7);
  box-shadow:
    0 14px 30px -12px rgba(84, 66, 44, 0.35),
    0 2px 6px rgba(84, 66, 44, 0.08),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);
  color: var(--mb-texto);
  text-decoration: none;
  backdrop-filter: blur(6px);
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
  -webkit-tap-highlight-color: transparent;
}

.mb-contatos__botao:hover {
  transform: translateY(-2px);
  background: #fbf8f1;
  box-shadow:
    0 20px 36px -14px rgba(84, 66, 44, 0.42),
    0 2px 6px rgba(84, 66, 44, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.9);
}

.mb-contatos__botao:active {
  transform: translateY(0) scale(0.99);
}

.mb-contatos__botao:focus-visible {
  outline: 2px solid var(--mb-marrom);
  outline-offset: 3px;
}

.mb-contatos__icone {
  flex: none;
  display: grid;
  place-items: center;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: var(--mb-marrom);
  color: #efe9dd;
}

.mb-contatos__icone svg {
  width: 26px;
  height: 26px;
}

.mb-contatos__texto {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.mb-contatos__legenda {
  font-size: 0.86rem;
  font-weight: 300;
  line-height: 1.3;
}

.mb-contatos__legenda strong {
  font-weight: 600;
}

.mb-contatos__titulo {
  font-size: 1.32rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  color: var(--mb-texto-forte);
  line-height: 1.25;
  overflow-wrap: anywhere;
}

/* Assinatura */
.mb-contatos__assinatura {
  align-self: flex-end;
  width: min(100%, 240px);
  font-size: 0.92rem;
  line-height: 1.5;
}

.mb-contatos__monograma {
  display: block;
  width: 150px;
  height: auto;
  margin: 0 0 6px 34px;
}

.mb-contatos__assinatura ul {
  list-style: none;
  margin: 0 0 16px;
  padding: 0;
  font-weight: 300;
  color: var(--mb-texto);
}

.mb-contatos__entregas {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  color: var(--mb-rosa);
}

.mb-contatos__entregas svg {
  flex: none;
  width: 30px;
  height: 30px;
  stroke-width: 2.4;
}

.mb-contatos__entregas span {
  display: flex;
  flex-direction: column;
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 1.15;
}

.mb-contatos__entregas small {
  font-size: 0.85rem;
  font-weight: 300;
  color: var(--mb-texto);
}

/* Celular: frascos laterais mais discretos para não cobrir os botões */
@media (max-width: 640px) {
  .mb-contatos__frasco--chanel {
    transform: translateX(42%);
    opacity: 0.9;
  }

  .mb-contatos__conteudo {
    padding-bottom: 40px;
  }

  .mb-contatos__assinatura {
    margin-bottom: clamp(20px, 6vw, 40px);
  }
}

@media (min-width: 900px) {
  .mb-contatos__conteudo {
    max-width: 480px;
    padding-top: 150px;
    padding-bottom: 80px;
  }

  .mb-contatos__frasco--chanel {
    top: 30%;
  }

  .mb-contatos__arco {
    width: 90vmax;
    height: 90vmax;
    left: 64vw;
    top: -30vmax;
  }
}

@media (prefers-reduced-motion: reduce) {
  .mb-contatos__botao {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Contatos.css"],"names":[],"mappings":"AAAA,4FAA4F;;AAE5F;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,qCAAqC;;EAErC,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,4GAA4G;EAC5G,sBAAsB;EACtB,qDAAqD;EACrD,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,aAAa;EACb,wBAAwB;EACxB,yDAAuY;AACzY;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,UAAU;EACV,UAAU;EACV,wCAAwC;EACxC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,MAAM;EACN,OAAO;EACP,gCAAgC;AAClC;;AAEA;EACE,QAAQ;EACR,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,OAAO;EACP,SAAS;EACT,gCAAgC;AAClC;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,wBAAwB;EACxB,uCAAuC;EAEvC,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uCAAuC;EACvC,gBAAgB;EAChB,mCAAmC;EACnC,yCAAyC;EACzC,iBAAiB;EACjB,uBAAuB;EACvB,6DAA6D;EAC7D,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;EAC5B,oBAAoB;EACpB,2BAA2B;EAC3B,0CAA0C;EAC1C;;;0CAGwC;EACxC,sBAAsB;EACtB,qBAAqB;EAErB,0BAA0B;EAC1B,2EAA2E;EAC3E,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB;;;0CAGwC;AAC1C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;EAC5B,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,uEAAuE;AACvE;EACE;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,cAAc;IACd,UAAU;IACV,YAAY;EACd;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Página /contatos — estética do flyer (bege texturizado, serifa suave, botões em pílula) */\n\n.mb-contatos {\n  --mb-fundo: #ece5d5;\n  --mb-fundo-claro: #f1ebdd;\n  --mb-texto: #6a625b;\n  --mb-texto-forte: #57504a;\n  --mb-marrom: #6e645b;\n  --mb-rosa: #e2457e;\n  --mb-botao: rgba(246, 242, 233, 0.92);\n\n  position: relative;\n  min-height: 100vh;\n  min-height: 100dvh;\n  overflow: hidden;\n  background-color: var(--mb-fundo);\n  background-image: radial-gradient(38% 30% at 50% 42%, var(--mb-fundo-claro) 0%, rgba(236, 229, 213, 0) 100%);\n  color: var(--mb-texto);\n  font-family: 'Lexend', 'Inter', system-ui, sans-serif;\n  -webkit-font-smoothing: antialiased;\n}\n\n.mb-contatos__grao {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  opacity: 0.32;\n  mix-blend-mode: multiply;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='180' height='180'%3E%3Cfilter id='g'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/%3E%3CfeColorMatrix values='0 0 0 0 0.45 0 0 0 0 0.4 0 0 0 0 0.33 0 0 0 0.55 0'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23g)'/%3E%3C/svg%3E\");\n}\n\n.mb-contatos__arco {\n  position: absolute;\n  width: 120vw;\n  height: 120vw;\n  left: 78vw;\n  top: -50vw;\n  border: 1px solid rgba(87, 80, 74, 0.35);\n  border-radius: 50%;\n  pointer-events: none;\n}\n\n/* Frascos decorativos */\n.mb-contatos__frasco {\n  position: absolute;\n  pointer-events: none;\n  user-select: none;\n  height: auto;\n}\n\n.mb-contatos__frasco--212 {\n  top: 0;\n  left: 0;\n  width: clamp(230px, 62vw, 560px);\n}\n\n.mb-contatos__frasco--chanel {\n  right: 0;\n  top: clamp(330px, 36%, 520px);\n  width: clamp(120px, 30vw, 400px);\n}\n\n.mb-contatos__frasco--egeo {\n  left: 0;\n  bottom: 0;\n  width: clamp(130px, 34vw, 380px);\n}\n\n/* Conteúdo */\n.mb-contatos__conteudo {\n  position: relative;\n  z-index: 1;\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 440px;\n  margin: 0 auto;\n  padding: clamp(150px, 40vw, 220px) 22px 48px;\n  display: flex;\n  flex-direction: column;\n}\n\n.mb-contatos__logo {\n  margin: 0 0 30px;\n  width: min(100%, 300px);\n  aspect-ratio: 2782 / 456;\n  background-color: var(--mb-texto-forte);\n  -webkit-mask: var(--mb-logo) center / contain no-repeat;\n  mask: var(--mb-logo) center / contain no-repeat;\n}\n\n.mb-contatos__chamada {\n  margin: 0 0 6px;\n  font-weight: 300;\n  font-size: 1.02rem;\n  letter-spacing: 0.2em;\n  line-height: 1.35;\n  color: var(--mb-texto);\n}\n\n.mb-contatos__destaque {\n  margin: 0 0 34px;\n  max-width: 11ch;\n  font-family: 'Fraunces', Georgia, serif;\n  font-weight: 600;\n  font-variation-settings: 'SOFT' 100;\n  font-size: clamp(2.35rem, 10.5vw, 3.1rem);\n  line-height: 1.02;\n  letter-spacing: -0.01em;\n  background: linear-gradient(180deg, #5c554f 0%, #7d746b 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n}\n\n.mb-contatos__destaque span {\n  font-weight: 500;\n}\n\n/* Botões */\n.mb-contatos__links {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 52px;\n}\n\n.mb-contatos__botao {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  width: 100%;\n  max-width: 340px;\n  box-sizing: border-box;\n  padding: 14px 24px 14px 16px;\n  border-radius: 999px;\n  background: var(--mb-botao);\n  border: 1px solid rgba(255, 255, 255, 0.7);\n  box-shadow:\n    0 14px 30px -12px rgba(84, 66, 44, 0.35),\n    0 2px 6px rgba(84, 66, 44, 0.08),\n    inset 0 1px 0 rgba(255, 255, 255, 0.8);\n  color: var(--mb-texto);\n  text-decoration: none;\n  -webkit-backdrop-filter: blur(6px);\n  backdrop-filter: blur(6px);\n  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.mb-contatos__botao:hover {\n  transform: translateY(-2px);\n  background: #fbf8f1;\n  box-shadow:\n    0 20px 36px -14px rgba(84, 66, 44, 0.42),\n    0 2px 6px rgba(84, 66, 44, 0.1),\n    inset 0 1px 0 rgba(255, 255, 255, 0.9);\n}\n\n.mb-contatos__botao:active {\n  transform: translateY(0) scale(0.99);\n}\n\n.mb-contatos__botao:focus-visible {\n  outline: 2px solid var(--mb-marrom);\n  outline-offset: 3px;\n}\n\n.mb-contatos__icone {\n  flex: none;\n  display: grid;\n  place-items: center;\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  background: var(--mb-marrom);\n  color: #efe9dd;\n}\n\n.mb-contatos__icone svg {\n  width: 26px;\n  height: 26px;\n}\n\n.mb-contatos__texto {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.mb-contatos__legenda {\n  font-size: 0.86rem;\n  font-weight: 300;\n  line-height: 1.3;\n}\n\n.mb-contatos__legenda strong {\n  font-weight: 600;\n}\n\n.mb-contatos__titulo {\n  font-size: 1.32rem;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  color: var(--mb-texto-forte);\n  line-height: 1.25;\n  overflow-wrap: anywhere;\n}\n\n/* Assinatura */\n.mb-contatos__assinatura {\n  align-self: flex-end;\n  width: min(100%, 240px);\n  font-size: 0.92rem;\n  line-height: 1.5;\n}\n\n.mb-contatos__monograma {\n  display: block;\n  width: 150px;\n  height: auto;\n  margin: 0 0 6px 34px;\n}\n\n.mb-contatos__assinatura ul {\n  list-style: none;\n  margin: 0 0 16px;\n  padding: 0;\n  font-weight: 300;\n  color: var(--mb-texto);\n}\n\n.mb-contatos__entregas {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 0;\n  color: var(--mb-rosa);\n}\n\n.mb-contatos__entregas svg {\n  flex: none;\n  width: 30px;\n  height: 30px;\n  stroke-width: 2.4;\n}\n\n.mb-contatos__entregas span {\n  display: flex;\n  flex-direction: column;\n  font-size: 1.2rem;\n  font-weight: 400;\n  line-height: 1.15;\n}\n\n.mb-contatos__entregas small {\n  font-size: 0.85rem;\n  font-weight: 300;\n  color: var(--mb-texto);\n}\n\n/* Celular: frascos laterais mais discretos para não cobrir os botões */\n@media (max-width: 640px) {\n  .mb-contatos__frasco--chanel {\n    transform: translateX(42%);\n    opacity: 0.9;\n  }\n\n  .mb-contatos__conteudo {\n    padding-bottom: 40px;\n  }\n\n  .mb-contatos__assinatura {\n    margin-bottom: clamp(20px, 6vw, 40px);\n  }\n}\n\n@media (min-width: 900px) {\n  .mb-contatos__conteudo {\n    max-width: 480px;\n    padding-top: 150px;\n    padding-bottom: 80px;\n  }\n\n  .mb-contatos__frasco--chanel {\n    top: 30%;\n  }\n\n  .mb-contatos__arco {\n    width: 90vmax;\n    height: 90vmax;\n    left: 64vw;\n    top: -30vmax;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .mb-contatos__botao {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
